import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { Button, Field, Alert } from "@evolua/ui";
import { AuthApiError, passwordForgot } from "../../auth/auth-api.js";
import { getAuthMode } from "../../auth/config.js";
import { AuthLayout } from "./AuthLayout.js";

export function ForgotPasswordPage() {
  const mode = getAuthMode();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [devToken, setDevToken] = useState<string | undefined>();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setDevToken(undefined);
    setPending(true);
    try {
      if (mode === "demo") {
        setMessage(
          "Modo demo: recuperação real exige VITE_AUTH_MODE=api e API com Cognito (ou AUTH_MODE=disabled com devToken).",
        );
        return;
      }
      const res = await passwordForgot(email.trim());
      setMessage(res.message);
      setDevToken(res.devToken);
    } catch (err) {
      setError(
        err instanceof AuthApiError
          ? err.detail || "Não foi possível solicitar recuperação."
          : "Falha de rede.",
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthLayout
      title="Recuperar senha"
      lead="Informe seu e-mail. Se a conta existir, enviaremos instruções."
    >
      <form className="evolua-auth__form" onSubmit={onSubmit}>
        <Field
          label="E-mail"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error ? <Alert tone="danger">{error}</Alert> : null}
        {message ? <Alert tone="info">{message}</Alert> : null}
        {devToken ? (
          <div>
            <p className="evolua-auth__lead">devToken (AUTH_MODE=disabled):</p>
            <div className="evolua-auth__secret">{devToken}</div>
          </div>
        ) : null}
        <Button type="submit" loading={pending}>
          Enviar instruções
        </Button>
      </form>
      <div className="evolua-auth__links">
        <Link to="/redefinir-senha">Já tenho o código</Link>
        <Link to="/login">Voltar ao login</Link>
      </div>
    </AuthLayout>
  );
}
